module.exports = __webpack_public_path__ + "img/canpay-logo-new.02ac8733.png";